const EPReferralTemplate = (data: any) => {
  const d = data.data;
  // Date conversions
  const dobValue = new Date(d.client_dob);
  let client_dob_str;
  if (isNaN(dobValue.getTime())) {
    client_dob_str = "";
  } else {
    client_dob_str = dobValue.toLocaleDateString();
  }

  const planStartValue = new Date(d.plan_start);
  let plan_start_str;
  if (isNaN(planStartValue.getTime())) {
    plan_start_str = "";
  } else {
    plan_start_str = planStartValue.toLocaleDateString();
  }

  const planEndValue = new Date(d.plan_end);
  let plan_end_str;
  if (isNaN(planEndValue.getTime())) {
    plan_end_str = "";
  } else {
    plan_end_str = planEndValue.toLocaleDateString();
  }

  const tacInjuryValue = new Date(d.tac_injury_date);
  let tac_injury_date_str;
  if (isNaN(tacInjuryValue.getTime())) {
    tac_injury_date_str = "";
  } else {
    tac_injury_date_str = tacInjuryValue.toLocaleDateString();
  }

  const wcInjuryValue = new Date(d.wc_injury_date);
  let wc_injury_date_str;
  if (isNaN(wcInjuryValue.getTime())) {
    wc_injury_date_str = "";
  } else {
    wc_injury_date_str = wcInjuryValue.toLocaleDateString();
  }

  return (
    <div style={{ margin: "0 50px" }}>
      <h1
        style={{
          color: "rgb(17, 82, 190)",
          fontSize: "24px",
          lineHeight: 1.2,
          textAlign: "center",
          margin: "24px 0",
        }}
      >
        New Exercise Physiology Referral
      </h1>
      <h2
        style={{
          color: "rgb(90, 35, 148)",
          fontSize: "20px",
          margin: "12px 0",
        }}
      >
        Client Information
      </h2>
      <b>Name:</b> { d.client_name }<br />
      <b>Date of birth:</b> { client_dob_str }<br />
      <b>Address:</b> { d.client_address }<br />
      <b>Gender:</b> { d.client_gender }<br />
      <b>Phone:</b> { d.client_phone }<br />
      <b>Email:</b> { d.client_email }<br /><br />

      <b>Medicare number:</b> { d.medicare_num }<br />
      <b>Medicare IRN:</b> { d.medicare_irn }<br />
      <b>Medicare expiry date:</b> { d.medicare_expiry }<br /><br />

      <b>Private health fund:</b> { d.private_cover_fund }<br />
      <b>Member number:</b> { d.private_cover_num }<br /><br />

      <b>Reason for referral:</b> { d.referral_reason }<br /><br />

      <b>Emergency contact name:</b> { d.client_emergency_contact }<br />
      <b>Emergency contact phone:</b> { d.client_emergency_phone }

      <h2
        style={{
          color: "rgb(90, 35, 148)",
          fontSize: "20px",
          margin: "20px 0 12px 0",
        }}
      >
        Referrer Information
      </h2>
      <b>Participant or referrer?:</b> { d.referrer_id }<br />
      <b>Referrer profession:</b> { d.referrer_profession }<br /><br />

      <b>Referring Practice name:</b> { d.referrer_org }<br />
      <b>Provider number:</b> { d.ref_provider_num }<br />
      <b>Phone:</b> { d.ref_provider_phone }<br />
      <b>Email:</b> { d.ref_provider_email }<br />
      <b>Used our service before?:</b> { d.ref_previous_contact }

      <h2
        style={{
          color: "rgb(90, 35, 148)",
          fontSize: "20px",
          margin: "20px 0 12px 0",
        }}
      >
        Goals
      </h2>
      <ul>
        <li>{ d.goal_one }</li>
        <li>{ d.goal_two }</li>
        <li>{ d.goal_three }</li>
        <li>{ d.goal_four }</li>
      </ul>

      <h2
        style={{
          color: "rgb(90, 35, 148)",
          fontSize: "20px",
          margin: "20px 0 12px 0",
        }}
      >
        Funding
      </h2>
      <b>Funding pathway:</b> { d.funding_pathway }<br />
      <b>If other:</b> { d.funding_pathway_other }

      { d.funding_pathway=='NDIS' && <div><h2
        style={{
          color: "rgb(90, 35, 148)",
          fontSize: "20px",
          margin: "20px 0 12px 0",
        }}
      >
        NDIS
      </h2>
      <b>NDIS number:</b> { d.ndis_num }<br />
      <b>Plan start date:</b> { plan_start_str }<br />
      <b>Plan end date:</b> { plan_end_str }<br />
      <b>Primary disability:</b> { d.primary_disability }<br />
      <b>Support coordinator name:</b> { d.sc_name }<br />
      <b>Support coordinator phone:</b> { d.sc_phone }<br />
      <b>Support coordinator email:</b> { d.sc_email }<br />
      <b>Funding claim type:</b> { d.fund_type }<br />
      <b>If plan managed, plan manager email: </b> { d.fund_plan_email }</div> }

      { d.funding_pathway=='TAC' && <div><h2
        style={{
          color: "rgb(90, 35, 148)",
          fontSize: "20px",
          margin: "20px 0 12px 0",
        }}
      >
        TAC
      </h2>
      <b>Claim number:</b> { d.tac_claim_num }<br />
      <b>Case manager name:</b> { d.tac_case_manager_name }<br />
      <b>Case manager phone:</b> { d.tac_case_manager_phone }<br />
      <b>Case manager email:</b> { d.tac_case_manager_email }<br />
      <b>Date of injury:</b> { tac_injury_date_str }<br />
      <b>Occupation:</b> { d.tac_occupation }<br />
      <b>Current capacity:</b> { d.tac_current_capacity }</div> }

      {d.funding_pathway=='WorkCover' && <div><h2
        style={{
          color: "rgb(90, 35, 148)",
          fontSize: "20px",
          margin: "20px 0 12px 0",
        }}
      >
        WorkCover
      </h2>
      <b>Claim number:</b> { d.wc_claim_num }<br />
      <b>Case manager name:</b> { d.wc_case_manager_name }<br />
      <b>Case manager phone:</b> { d.wc_case_manager_phone }<br />
      <b>Case manager email:</b> { d.wc_case_manager_email }<br />
      <b>Date of injury:</b> { wc_injury_date_str }<br />
      <b>WorkCover insurer:</b> { d.wc_insurer }<br />
      <b>Employer: </b> { d.wc_employer }<br />
      <b>Current capacity: </b> { d.wc_current_capacity }<br /></div> }

      {d.funding_pathway=='DVA' && <div><h2
        style={{
          color: "rgb(90, 35, 148)",
          fontSize: "20px",
          margin: "20px 0 12px 0",
        }}
      >
        DVA
      </h2>
      <b>Card number:</b> { d.dva_card_num }<br />
      <b>Card type:</b> { d.dva_card_type }<br />
      <b>Accepted condition:</b> { d.dva_accepted_condition }</div> }
    </div>
  )
}

export default EPReferralTemplate